import SwitchButton from '@jimmyboys/liita-ui/dist/components/SwitchButton'
import React from 'react'
import { useController } from 'react-hook-form'

const HFSwitchButton = (props) => {
	const { name, ...attributes } = props
	const {
		field: { ref, value, ...field },
	} = useController({ name })

	return <SwitchButton {...attributes} checked={value || false} {...field} />
}

export default HFSwitchButton
